var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-card-wrapper" }, [
    _c("div", { staticClass: "detail-card-title" }, [
      _vm._v(_vm._s(_vm.cardTitle))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "detail-card-body" }, [
      _vm.formatCardTitle
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(_vm._s(_vm.getEntityLabel + " Name"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatCardTitle))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatInstruction
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Instruction")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatInstruction))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatIngredients
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Compound (Ingredients)")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatIngredients))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatProcedureOutcome
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Procedure Outcome")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatProcedureOutcome))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatProcedureObservations
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Procedure Observations")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatProcedureObservations))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatDoseAmount
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Dose amount")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatDoseAmount))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatDoseUnit
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Dose units")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatDoseUnit))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatRoute
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [_vm._v("Route")]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatRoute))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatValues
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(_vm._s(_vm.getEntityLabel + "Value"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatValues))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatUnits
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(_vm._s(_vm.getEntityLabel + "Units"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatUnits))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatReferenceRange
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(_vm._s(_vm.getEntityLabel + "Reference Range"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatReferenceRange))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatInterpretation
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getEntityLabel + "Interpretation (high or low)") +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatInterpretation))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatNotes
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(_vm._s(_vm.getEntityLabel + "Interpretation Notes"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatNotes))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatDate
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v(_vm._s(_vm.formatDateLabel))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatDate))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatEndDate
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("End Date")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatEndDate))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatStatus
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [_vm._v("Status")]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatStatus))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatReactions
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Reactions")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatReactions))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatSeverityReactions
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Reaction Severity")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatSeverityReactions))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatPractitioner
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Practitioner")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatPractitioner))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.formatTestingCompany
        ? _c("div", { staticClass: "detail-body-cell" }, [
            _c("div", { staticClass: "detail-card-label" }, [
              _vm._v("Testing company")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-card-data" }, [
              _vm._v(_vm._s(_vm.formatTestingCompany))
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }